var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._g(_vm._b({staticClass:"text-left",class:_vm.getAlertColor + '--text',attrs:{"outlined":"","text":"","color":_vm.getTextColor,"icon":_vm.getIcon}},'v-alert',_vm.$props,false),_vm.$listeners),[_c('span',{class:_vm.getTextColor + '--text'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }